
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"2 min read","minutes":1.28,"time":76800,"words":256}
/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The main engine of each turn, an Activity is the social event hosted in a particular room or outdoor space at a player’s country estate. The Activity is seen in small white letters on each improvement tile immediately below the tile name.`}</p>
    <div className="flavor-text">
      <p>{`The independently wealthy landed gentry of Victorian Britain derived their income from legacy wealth and property, and generally did not need (or want) to work. The gentry lifestyle was therefore filled by social activities such as formal dinners, balls, hunting, riding, picnics, and recitals, all of which may take place in a game of Obsession.`}</p>
      <p>{`Activities are limited by the family’s reputation (the largest number on each player board). This restriction simply reflects limitations on a family emerging from a period of frugal living; a family who has just begun renovating their country house and expanding the domestic staff can hardly host a ball; it would be a disaster and few would come. Only when a family has made improvements, cultivated the gardens, hired and trained domestic staff, and re-entered society with a purpose can they host balls or brave recitals, formal dinners, and shooting parties. The increasing reputation on the player board reflects the family’s increasing ability to stage grand events attended by the most desirable guests.`}</p>
    </div>
    <p>{`Improvement tiles represent a room or outdoor space where an Activity may take place. These Activities are the focus of Obsession gameplay. Each turn, a
player will either pass or select an Activity to host at their country estate.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {
  "title": "Activity"
}

